<template>
  <!-- <v-container fluid grid-list-md class="pa-0"> -->
  <!-- <v-layout row wrap class="header mt-0"> -->
  <!-- <v-flex xs12 py-0 px-2 color="primary" flex-row> -->
  <header class="header">
    <!-- <router-link to="/dashboard/"> -->
    <img src="/static/logo.png" class="slashdr--logo" @click="routeRedirect()">
    <!-- </router-link> -->
    <!-- <el-tag type="warning"></el-tag> -->
    <!-- <span>{{version}}</span> -->
    <div class="floatRight">
      <v-flex>
        <el-button
          type="danger"
          v-if="checkedItems.length === 1"
          color="accent"
          class="add-pt-btn"
          dark
          slot="activator"
          id="cancel"
          @click="cancelAppointment"
        >Cancel Appointment</el-button>
        <el-button
          type="danger"
          v-if="checkedItems.length > 1"
          color="accent"
          class="add-pt-btn"
          dark
          slot="activator"
          id="cancel"
          @click="cancelAppointment"
        >Cancel Appointments</el-button>

        <el-button
          type="info"
          v-if="checkedItems.length > 0"
          color="accent"
          class="add-pt-btn"
          dark
          slot="activator"
          id="cancelTheCancel"
          @click="toggle"
        >Cancel</el-button>

        <!-- <router-link :to="{ name: 'profileAdd' }">
              <el-button type="primary">Registration</el-button>
        </router-link>-->
        <!-- <router-link :to="{ name: 'profileEdit' }">profileEdit</router-link> -->
        <!-- TODO: Dummy -->

        <!-- <v-flex xs12 lg6> -->
        <v-menu
          ref="menu1"
          :close-on-content-click="false"
          v-model="menu1"
          lazy
          transition="scale-transition"
        >
          <v-text-field
            slot="activator"
            v-model="date"
            persistent-hint
            @blur="date = parseDate(dateFormatted)"
          ></v-text-field>
          <v-date-picker
            v-model="date"
            @input="menu1 = false"
            :events="arrayEvents"
            event-color="green lighten-1"
            :allowed-dates="isAllowedDate"
          ></v-date-picker>
        </v-menu>

        <!-- <el-dropdown v-if="doctors.length > 1">
          <el-button type="primary">
            Select doctor name
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <div v-for="item in doctors" :key="item.doctor_id">
              <el-dropdown-item
                @click.native="getOption(item.clinic_id, item.doctor_id)"
              >{{ item.doctor_name }}</el-dropdown-item>
            </div>
          </el-dropdown-menu>
        </el-dropdown>-->

        <el-select
          v-model="doctor_id"
          default-first-option
          v-if="doctors.length > 1"
          placeholder="Select doctor name"
        >
          <el-option
            v-for="item in doctors"
            :key="item.doctor_id"
            :label="item.doctor_name"
            @click.native="getOption(item.clinic_id, item.doctor_id)"
            :value="item.doctor_id"
          ></el-option>
        </el-select>

        <el-dropdown>
          <el-button type="primary">
            Settings
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="this.doctors.length <= 1">
              <router-link to="/forms/employee-registration">Forms</router-link>
            </el-dropdown-item>
            <el-dropdown-item disabled>Analytics</el-dropdown-item>
            <el-dropdown-item>
              <router-link to="/about">About</router-link>
            </el-dropdown-item>
            <el-dropdown-item>v{{version}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-button type="primary" dark slot="activator">
          <router-link to="/allPatients" style="color:#fff">All Patients</router-link>
        </el-button>

        <AddPatient/>
        <el-button type="primary" @click.prevent="logout()">Logout</el-button>
      </v-flex>
    </div>
  </header>
  <!-- </v-flex> -->
  <!-- </v-layout> -->
  <!-- </v-container> -->
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import $ from "jquery";
import AddPatient from "./AddPatient.vue";
import { api } from "../api.js";
import { get } from "axios";
import * as moment from "moment";

function compareTime(time1, time2) {
  return new Date(time1) > new Date(time2); // true if time1 is later
}

export default {
  name: "Header",
  components: {
    AddPatient
  },
  data() {
    let date = new Date().toISOString().substr(0, 10);
    if (this.$route.params.date) {
      date = new Date(this.$route.params.date).toISOString().substr(0, 10);
    }
    return {
      // allowedDates: ()=> {
      //     const dt = new Date(), y = dt.getFullYear(), m = dt.getMonth();
      //     const firstOfLastMonth = new Date(y, m - 1, 1);
      //     const firstOfNextNextMonth = new Date(y, m + 2, 1);
      //     return {from:firstOfLastMonth, to:firstOfNextNextMonth}
      // },
      fav: true,
      menu: false,
      message: false,
      hints: true,
      date: date,
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      dtList: [
        { date: "08-02-2018", queue: 1 },
        { date: "14-02-2018", queue: 1 },
        { date: "16-02-2018", queue: 3 },
        { date: "20-02-2018", queue: 1 },
        { date: "28-02-2018", queue: 1 }
      ],
      doctors: [],
      doctor_id: "",
      clinic_id: "",
      arrayEvents: null,
      doctor_name: ""
    };
  },
  mounted() {
    console.log(process.env.VERSION);
    // this.arrayEvents = ["2018-11-13"]
    this.arrayEvents = [...Array(6)].map(() => {
      const day = Math.floor(Math.random() * 30);
      const d = new Date();
      d.setDate(day);
      return d.toISOString().substr(0, 10);
    });
    this.getRecentAppointmentDateList();
    if (localStorage.getItem("doctors")) {
      this.doctors = JSON.parse(localStorage.getItem("doctors"));
      this.doctor_id = localStorage.getItem("doctor_id");
      this.clinic_id = localStorage.getItem("clinic_id");
      // this.doctor_name = localStorage.getItem("doctor_name");
      this.fetchDoctorName(this.doctor_id, this.doctors);
    }
    console.log("App mounted!");
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      window.location.href = `/appointments-on/${this.date}`;
    }
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    ...mapState([
      "checkedItems",
      "Waiting_list_pd",
      "queue_completed_pd",
      "queue_patient_details"
    ]),
    version: () => {
      return process.env.VERSION;
    }
  },
  methods: {
    ...mapMutations([
      "update_Waiting_list",
      "update_completed_list",
      "update_patient_list",
      "toggle"
    ]),
    ...mapActions(["delete", "changeAppointmentPosition"]),
    ...mapActions(["getdata", "changeAppointmentPosition"]),
    // cancelTheCancel() {
    //   this.checkedItems = []
    //   console.log(this.checkedItems);
    // },
    fetchDoctorName(doctor_id, doctors) {
      let doc_id = parseInt(doctor_id);
      let arrayDes = doctors;
      let find = arrayDes.find(item => {
        return item.doctor_id === doc_id;
      });
      let res = find.doctor_name;
      this.doctor_id = res;
    },
    getOption(clinic_id, doctor_id) {
      this.getdata(clinic_id);
      // setTimeout(this.getdata(), 1000);
      console.log("clinic_id", clinic_id);
      console.log("doctor_id", doctor_id);
      this.$router.push({
        path: "/dashboard/" + clinic_id + "/" + doctor_id
      });
      localStorage.setItem("clinic_id", clinic_id);
      localStorage.setItem("doctor_id", doctor_id);
    },
    routeRedirect() {
      let clinic_id = localStorage.clinic_id;
      let doctor_id = localStorage.doctor_id;
      this.getdata(clinic_id);
      this.$router.push("/dashboard/" + clinic_id + "/" + doctor_id);
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
      // window.reload()
    },
    async getRecentAppointmentDateList() {
      const dt = moment();
      const lastMonth = dt.subtract(1, "months");
      const nextMonth = dt.add(1, "months");
      const appointmentList = [];
      const { data: lastMonthAppointmentsRes } = await get(
        api + `/calender?month=${lastMonth.month()}&year=${lastMonth.year()}`
      );

      const [lastMonthAppointments] = lastMonthAppointmentsRes.list;

      const { data: currentMonthAppointmentsRes } = await get(
        api + `/calender?month=${dt.month()}&year=${dt.year()}`
      );

      const [currentMonthAppointments] = currentMonthAppointmentsRes.list;

      const { data: nextMonthAppointmentsRes } = await get(
        api + `/calender?month=${nextMonth.month()}&year=${nextMonth.year()}`
      );

      const nextMonthAppointments = nextMonthAppointmentsRes.list;
      console.log(`nextMonthAppointments`);
      console.log(nextMonthAppointments);
      if (lastMonthAppointments.length) {
        appointmentList.push(lastMonthAppointments);
      }

      if (currentMonthAppointments.length) {
        appointmentList.push(currentMonthAppointments);
      }

      if (nextMonthAppointments.length) {
        appointmentList.push(nextMonthAppointments);
      }

      console.log("here appointmentLists");
      console.log(appointmentList);
    },
    isAllowedDate(date) {
      const dt = new Date(),
        y = dt.getFullYear(),
        m = dt.getMonth();
      const firstOfLastMonth = new Date(y, m - 1, 1);
      const firstOfNextNextMonth = new Date(y, m + 2, 1);

      if (date) {
        return (
          compareTime(date, firstOfLastMonth) &&
          compareTime(firstOfNextNextMonth, date)
        );
      }
      // return true;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    cancelAppointment() {
      let waitingListToBeRemoved = [];
      let completedListToBeRemoved = [];
      let appointmentListToBeRemoved = [];
      // console.log(this.Waiting_list_pd[0])
      let checkWaitingList = this.Waiting_list_pd.filter((x, index) => {
        let indexToRemove = this.checkedItems.findIndex(y => y == x.id);
        if (indexToRemove == -1) {
          return x;
        } else {
          waitingListToBeRemoved.push(x.id);
        }
      });

      let checkCompletedList = this.queue_completed_pd.filter((x, index) => {
        let indexToRemove = this.checkedItems.findIndex(y => y == x.id);
        if (indexToRemove == -1) {
          return x;
        } else {
          completedListToBeRemoved.push(x.id);
        }
      });

      let checkAppointmentList = this.queue_patient_details.filter(
        (x, index) => {
          let indexToRemove = this.checkedItems.findIndex(y => y == x.id);
          if (indexToRemove == -1) {
            return x;
          } else {
            appointmentListToBeRemoved.push(x.id);
          }
        }
      );
      this.delete({
        checkWaitingList,
        checkCompletedList,
        checkAppointmentList
      });
    }
  }
};
</script>

<style scoped>
.brand {
  color: #fff;
  font-size: 2rem;
  margin-bottom: 0;
}

.add-pt-btn {
  /* margin-top: 10px; */
}
.header {
  background: #018fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem 0.5rem 0rem;
}
.header-logo {
  width: 60px;
}
.slashdr--logo {
  width: 40px;
  margin: 0rem 0.5rem;
}
/*.dialog__container{
  float: right
}*/
/*.add-pt-btn .btn .theme--dark .accent{
  float: right;
}*/
.floatRight {
  display: block;
}

/*#app,.application--wrap{
  display: block !important;
  width: 100% !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/Header.vue